module.exports = __webpack_public_path__ + "media/images/logo-operator-b4908836f01d26f0c88a1f60d94867f8.png";